import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

export interface ImportResult {
  message: string;
  filename: string;
  imported_data: {
    partners: Array<{ id: number; name: string }>;
    workers: Array<{ 
      id: number; 
      name: string; 
      type: string; 
      transport_type: string;
      geocoded: boolean;
      action: string;
    }>;
    stores: Array<{ 
      id: number; 
      address: string; 
      chain: string;
      geocoded: boolean;
      lat?: number;
      lng?: number;
      action: string;
    }>;
    programs: Array<{ id: number; name: string; partner: string }>;
    program_stores: Array<{ 
      id: number; 
      program: string; 
      store: string;
      visits_per_week: number;
      visit_time_minutes: number;
    }>;
  };
  summary: {
    partners: number;
    workers: number;
    stores: number;
    programs: number;
    program_stores: number;
  };
}

export const importEAPFile = async (file: File): Promise<ImportResult> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('filename', file.name);

  const endpoint = file.name.toLowerCase().endsWith('.csv') 
    ? '/api/v1/import/csv' 
    : '/api/v1/import/excel';

  const response = await axios.post(`${API_BASE_URL}${endpoint}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    }
  });

  return response.data;
};

export const validateEAPFile = (file: File): { isValid: boolean; error?: string } => {
  const allowedExtensions = ['.xlsx', '.xls', '.csv'];
  const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
  
  if (!allowedExtensions.includes(fileExtension)) {
    return {
      isValid: false,
      error: 'Неподдерживаемый формат файла. Поддерживаются только Excel (.xlsx, .xls) и CSV файлы.'
    };
  }

  const maxSize = 50 * 1024 * 1024; // 50MB
  if (file.size > maxSize) {
    return {
      isValid: false,
      error: 'Файл слишком большой. Максимальный размер: 50MB.'
    };
  }

  return { isValid: true };
}; 